/** PostHog event names for RequestForm V1 analytics (WEB-10991). */
export const QUOTE_REQUEST_FORM_V1_EVENTS = {
  ENTER_FORM: "RequestFormV1: Enter Form",
  LOAD_TEMPLATE: "RequestFormV1: Load Template",
  ABANDON_SECTION: "RequestFormV1: Abandon Section",
  REENTER_DRAFT: "RequestFormV1: Reenter Draft",
  ADD_HANDLING_UNIT: "RequestFormV1: Add Handling Unit",
  ADD_COMMODITY: "RequestFormV1: Add Commodity",
  SELECT_ALL_PROVIDERS: "RequestFormV1: Select All Providers",
  LOG_FORM_ERROR: "RequestFormV1: Log Form Error",
  VIEW_CONFIRMATION: "RequestFormV1: View Confirmation",
  SUBMIT_FORM: "RequestFormV1: Submit Form",
} as const;

export type QuoteRequestFormV1EventName =
  (typeof QUOTE_REQUEST_FORM_V1_EVENTS)[keyof typeof QUOTE_REQUEST_FORM_V1_EVENTS];
